export enum PointMeasurementOption {
  ThreeD = '3d',
  XYCoordinates = 'showXYCoordinates',
  ZCoordinate = 'showZCoordinate',
}

export interface MainToolbarMeasurementCapability {
  readonly id: string;
  readonly label: string;
  readonly icon: string;
  start(): void;
  isActive(): boolean;
  isDisabled?(): boolean;
  stop(): void;
}
